export default {
  header: {
    self: {},
    items: [
    ]
  },
  aside: {
    self: {},
    items: [
      {
        title: "Préstamos",
        root: true,
        icon: "flaticon2-layers-1",
        bullet: "dot",
        submenu: [
          {
            title: "Lista de operaciones",
            page: "dashboard",
            // page: "loans", // TODO it would be named loans and not dashboard
            //icon: "flaticon2-line-chart"
          },
          // {
          //   title: "Vouchers",
          //   page: "vouchers",
          //   //icon: "flaticon2-paper"
          // }
        ]
      },
      {
        title: "Comercios",
        // title: "Finket / Proveedores",
        root: true,
        icon: "flaticon2-soft-icons-1",
        bullet: "dot",
        submenu: [
          {
            title: "Lista de comercios",
            desc: "Lista de todos los comercios",
            page: "commerce",
            //icon: "flaticon2-soft-icons-1"
          },
          {
            title: "Lista de operaciones",
            desc: "Lista de préstamos todos los comercios",
            page: "commerce-signs",
            //icon: "flaticon2-soft-icons-1"
          },
          {
            title: "Lista de préstamos",
            desc: "Lista de préstamos de los clientes de todos los comercios",
            page: "commerce-lists",
            //icon: "flaticon2-soft-icons-1"
          },
        ]
      },
    ]
  }
};
